import React from 'react';

import { useIntlReexport } from 'src/application/hooks/useIntlReexport';
import { widgetMessages } from 'src/translates/widgetMessages';

import PDFIcon from './pdf-icon.svg';
import { Button, ButtonVariant, ExternalLinkWrapper } from '@ael/shared-components-library';

import './pdf-thumbnail.scss';

type PDFWidgetProps = {
  src?: string;
  fileName?: string;
};

export const PDFThumbnail: React.FC<PDFWidgetProps> = ({ src, fileName }) => {
  const { formatMessage } = useIntlReexport();

  return (
    <div className="pdf-thumbnail">
      <img src={PDFIcon} className="pdf-thumbnail__thumbnail" alt="pdf" />
      <div className="uno-pb-12px">{fileName}</div>
      <ExternalLinkWrapper href={src}>
        <Button variant={ButtonVariant.PRIMARY} disabled={!src}>
          {formatMessage(widgetMessages.pdfWidgetViewPdf)}
        </Button>
      </ExternalLinkWrapper>
    </div>
  );
};
